import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { ActionButtonSubmit } from "../../model/action-button-submit";
import { TranslateService } from "@ngx-translate/core";
import { Messages } from "../../model/messages";
import { TooltipDirective } from "ngx-bootstrap/tooltip";

export enum ActionButtonResult {
  SUCCESS,
  FAILURE,
  NONE,
}

import { PALETTE } from "../../model/palette";

@Component({
  selector: "action-button",
  templateUrl: "./action-button.component.html",
  styleUrl: "./action-button.component.css",
})
export class ActionButtonComponent {
  @Output() actionEvent: EventEmitter<ActionButtonSubmit> =
    new EventEmitter<ActionButtonSubmit>();
  @Input() label: string;
  @Input() icon: string = "";
  @Input() errorMessage: string;
  @Input() successMessage: string;
  private _fullWidth = true;
  _disabled = false;

  @ViewChild(TooltipDirective) tooltips: TooltipDirective;

  enableSpinner = false;
  receivedMessage: string;
  ngStyle: object;
  classes = "btn btn-light-blue align-self-end w-100 ";

  constructor(private translate: TranslateService) {}

  @Input() set disable(value: boolean) {
    this._disabled = value;
    this.setClasses("btn-light-blue");
  }

  @Input() set fullWidth(value: boolean) {
    this._fullWidth = value;
    this.setClasses("btn-light-blue");
  }

  showSpinner() {
    if (!this.enableSpinner) {
      this.enableSpinner = true;
      this.ngStyle = {
        "background-image": "url(/assets/img/loading.gif)",
        "background-repeat": "no-repeat",
        "background-position": "20px",
        "background-size": "2.5em 2.5em",
      };
    }
  }

  hideSpinner() {
    this.enableSpinner = false;
    this.ngStyle = {};
  }

  actionFeedback(feedback: ActionButtonResult) {
    this.hideSpinner();
    this.enableSpinner = false;
    this.ngStyle = {};
    this.setClasses("btn-light-blue");
    if (feedback === ActionButtonResult.NONE) {
      return;
    }
    this.showMessage(feedback);
    if (feedback === ActionButtonResult.SUCCESS) {
      this.ngStyle = {
        "background-image":
          "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMEAAADACAYAAAC9Hgc5AAABhWlDQ1BJ" +
          "Q0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TS0UqChYUcchQXbQgKuqoVShChVArtOpgcv0SmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5O" +
          "ik6CIl/i8ptIjx4Lgf7+497t4BQq3EVLNtFFA1y0jGY2I6syIGXxFAL7oxhWGZmfqsJCXgOb7u4ePrXZRneZ/7c3RmcyYDfCLxDNMNi" +
          "3ideHLT0jnvE4dZUc4SnxOPGHRB4keuKy6/cS44LPDMsJFKzhGHicVCCystzIqGSjxBHMmqGuULaZeznLc4q6UKa9yTvzCU05aXuE5z" +
          "AHEsYBESRCioYAMlWIjSqpFiIkn7MQ9/v+OXyKWQawOMHPMoQ4Xs+MH/4He3Zn58zE0KxYDAi21/DALBXaBete3vY9uunwD+Z+BKa/r" +
          "LNWD6k/RqU4scAV3bwMV1U1P2gMsdoO9Jlw3Zkfw0hXweeD+jb8oAPbdAx6rbW2Mfpw9AirpK3AAHh8BQgbLXPN7d3trbv2ca/f0AzN" +
          "Vyy+mzv+MAAAAGYktHRAD/AP8A/6C9p5MAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfkBRcRBBlZzLfhAAAAGXRFWHRDb21tZ" +
          "W50AENyZWF0ZWQgd2l0aCBHSU1QV4EOFwAAEaJJREFUeNrtnV1sU+cZx5/jxLHj2AsjtISE75DjfDiBbMb5KlrTqRXTRBvW7qKrqNSq" +
          "labdVJtGd7VecIcmTWIXU6VJmbZJqzQosE5TOzaVMdQYUjZI4iSOSSBA4tDRNFBnTp1gn12kBpPG9jn2+3nO8+cCJbF9js95fu//ed7" +
          "zfiixWAxQKCvLhpcAhRCgUAgBCoUQoFAIAQplZZXiJSCjqYQTZuMajM0tw3RcefD7u18k4fJd+4OfN5cn4fRt14Ofq+xJ2OG6/8hnta" +
          "1bhnXOkofvcWnQWGWHzq8n8EJTkIJdpMYVnHc8CPazt21w6Z7jkb9X2ZMwt1xS9HHW+pwqexL2VSWgvlKBQOUX0FDtge2OL/CmIAR0A/" +
          "7vt+4/aNFXB7wo8lcmoG3dMvjW2+DVXSm8cQhBceqbsMHZWXgkbZFFVfYkAAC85UvA9zfeA4/HgzcUITAW+OfnHERSGVGAOL77JtQ6ls" +
          "Hj8SAQCIE1An8tEPoDk4/8DoGwOATBeQf8OrQsZapDEgQEwoIQTCWc8Mq5pLCFLW31VsfhaN101r9bGQbTQ/DBjWX44eWvmTbdMaLx7k" +
          "je15gBhm/P7oGL9RMaAMDCwoJiWQj6JmxwJOTA4M/QYe8ivLbhlq7XygqD2+3WVv8uHwilGPzW0dV7GsAGfa+NxWKQbiBramqkDP7Mv+" +
          "UCwTRjh4LzDug5Y0cAKCgajYKoGUP7jD8nAGl1RNvNnQ4dOm8j2ttDatiDaMrVS6RXIqVJeoJfT1oktRP0Tdhg++ly4t2dZnWS1QP1Cl" +
          "EsFoNoNMr1eyjlSotRAHJBIyUEUwkn9JyxwxuXXZj6GNDm8qTUKVJXZCX1qSipGCr4M6YD8qdDR4ZK4Bfj5RjRBehD/3WodSwT/1wWKV" +
          "IhLb/elEiq3qGeM3bLPuwqVv7KBBUA0ilSGgbSej7RDH+rukENAGmcIDjvgBfP2YROfUQvpo8H5qHVfof6cUh2p5Jq/XMBIEVNcGSoBJ" +
          "75h1343F/k8+utjjMBgFSt0HGzgxgAiVTi2XwPy4R2AtJdn7KqGJd5fdsC/HQz+96cQusEkq1/63iT0l87kPd1QkIwlXDCk+8r0vX8pO" +
          "cLby5PQn2l8mBucFqbXMqaUyGD84/WOZnzlM/etsH1eGlB1+JYWxz2u6a5XhMj6RFRAMJNSv/mAV2vFQ4CWYY9ZM71fXpLKZNJ8Om5zW" +
          "dnAaYXS9bsJKiyJ+F7NYtcWv9CQeiMtsOwOkIMgJYxnxLcckH364WCoG/CBm9cdgkd9D2bAJ7aUibM5PaphBPCt1fuIau8nyQIJFt/AI" +
          "CWK81KcNdFQ+8RBoKfDAD85oZbyMD/kU+u5U4yB7+JpMw6oWOmA0LeEFEAWq/tUPofHzb8PiEgEK0A7q2Ow0tbE7B/m136olo0IDweD2" +
          "zatEkj/bl65g1kUykC8LDVf3XnErzstcN2RwoA5AdgdevLe8wPAAgHAHcn4P0EOHN5Eiut1cMDhoPwHIyoY8IBwBWCnjP2grv+SAFgte" +
          "DnlSqpqqrR+FwSAHBLhw6dt3FzgHTa81ZrEqyudKpE0xlEB4CLE/DsBeqtjsMf9uEShSxc4QXtIAx5R4QHgDkEvIZBV9mT8M/vaLhwLS" +
          "MYaLX+NAAAYDiArm/CxgWAw95FmOpdRAAMpkhWAYCZE/B4EoytP3tXkBEAJoXxVMIJR0IK05uHuT85V0jDkEvPpw7CcMOIlAAwcYLtp8" +
          "uZdYNityc9ZetBotn6swCAuhMcOm9jCsBK+oMA0FBNTc1X0iMzAEAVgr4JNsMh0mP4zz6zjJHKMD2iDcDs7KzCan0jKr1DUwkns0J4X1" +
          "UCAWCo/Xefpg5AJBJRWK5vRAWCJ99nUwhjAcxWnTN+GGwMUQcg82cWvZfEISBVB6QHtyEAYsjtdmvD3jBTANIQ0AaBKATBeQexOiAXSI" +
          "e9iwgAYwBoH2MtAFi5AVEIXjxH/wH0Ye8iDn6zEAAsQCAWtUeGSqh3h/ZWxxEAkwHQOOrTVUAKD8FUwkl9XBDWAOzk17nmf7HaHWlW/l" +
          "x6UvfrafUWEYHglXN0W2d/ZQIBYKSOmb0QplwAA6wsi3IcThl+Hw1HKBqCvomVxaFoAoDPAdjI7rIfCHnHqAPQHG5S3i05WdB7aUBQ9N" +
          "ghmmODcCSoufJ/AIDJ/006kjPJpWI+g/RS8EU5Ae1i+O22zxEAEwEAAFAsADTcoCgI+q6VUbtYr29bMMW6PwjAQ+npCuVRJBcMAQkXyP" +
          "ZU2F+ZgF8GMEARADYqGAISLpANot9+C/chQwDYpUUFQXBkiF6QHmuLYx1gIgAWFhaoDYnmCkHftTIqBbG/EmeF0VTXJ93MAQCgu7EfCRA" +
          "MQ9A3QW+2GKZB9PTELT8M1Q0yByAtU0FwJERn5bjXty1gGkRJ3bMBuNIYZgZAy3jTmjWAqCAYgmAq4aTiAlX2JPYGUVLn9F4YrB9lBoAv" +
          "3KQEs+wTZgoIfj6wROVLvN32OUYrDQBm2mG4YYwZAIlU4tkLefYJI7nFKykQDEFwfo58KlRlT+JDMRpF8Ew7DHtHNJbHXI4v/0XP61hNo" +
          "CcOwQc3lqmkQugC5GV32Q8MMQbAyPIoNCBg4gRHx8mvHoEuQF7OCuebDpvjPVEBoKlCQdAFwVTCSWU/AXQB8gCUKqVHZQCARm1QKAS6Jg" +
          "J8eGsJSK/ThS5AVq4K1x9tiu1FKzoAk5rg7Cz5A7+6cwkjV2IAmsaaigZAFDfQBQGNXqGXvegCsgIwGZ90DGwZEPJ6UIGARq+QvzKBT4c" +
          "lBQAAYGNqIzEbF6G7NC8EA/ecxA/6M28cI7hIVbgrrvMAgHQdIEJ3aV4ISM8ew4KYDAAKKNtlB0CKwpjGWKF9VQmM4iJkd9kPmA0A0m5A" +
          "1AlWukbJqmcTBnKh6pwJAOsHYQAALeFGqg7Auy7ICUHoM/ITXHDSTGHqjgZg2Duq8Th2cPPH0l0vI26QE4LLd8nm7v5KTIUKdYBBlQ8Ar" +
          "OoAnm6QEwLSQyV6qtEFjKpjei83B2BZCPOsC7JCEJzHB2S8tW+2A0IM5wPwAoC3skIwNkd+/U98QKZfT9z0w+X6EBcAdkeapAfA4/Hodo" +
          "OsEEzHyV4HrAf0KxD1w5WmsMbr+B/VDHALXKHSobO3ye4607YOV5bWq1GVHwBWSoPyQkC6KPatt2F06xDLdYFEA4BXccwsMp/aUoYRLjA" +
          "ALSaoA4g7Qb4tVLEoNg8AvvFGJVgzAAgBJVXZk1gUCwwAAMCFWnGeCPN4aGbLlkvtcN0ncoC55RJ8SCYwAGYvhPXUBVmd4NBOcunQj3fc" +
          "xWhHAORLh/a7ponUBb3VceEWWxJBzgrnmzyP3zzaLCQAQqVDAABv+YrP5V/aivXAanXM7AXWS6Os1sWtF/FG5IIgTeN+1zT0Vhc+FfJD/" +
          "3Votd/Bq5yh7lsBYLFNKqZBBNKhtI7WTcOxNuMgHPYuQq0DnxKv1mDjKAIgGwRpRzjWFtdVI/grE3A8MA+vbbiFV1ewQnjP1UYEYA2tuZ" +
          "l3ru0xZxJ2+NX0Rjg/54C55RKosidhh+s+bC5PwktbE2umP7SW40YAzOkCJLdn1RN/htdWrHUsw9G6aYA6bEEQAAulQygEACFASQtAtv3" +
          "DrCI9zx0QAkrqmG4X4jyy7R9mFekZNlGK4Upe37rth1BDGNMgmdMhHOZQnP69iz8ALZFmBADTIevWAQAAwRocFoGFsYUBwDSIAATFbo6MA" +
          "CAAWBNYTEtlS4+JcB6t4w0IgKjpkJmdpXvWD+vL1v9XhHPpr70k/fXkEStYExSpwfowpkGYDmEdwFst49gdmk3CdJGaMR0SBQAAgGCtebp" +
          "DpUqHrOwWIgGAaRBHCKzajdoe3SvMubRNYm8QVQh4b6YmJADXu2BEHRPGBc5vvGSqYCQdI3pj2JAT1Kv1sRdSBy3bYoy0DGEaZEKobAYAW" +
          "ExpqYrL3qFUvVp//2Dqu5ZyApHqgNawOecKC+cEmR/wQuo50DTNoYCiKIqiAEBJqCGiqapqifUVRQIAAKBfwt0keYhYOtQLvTDYMJpSvox/" +
          "BVYaoS//V1RV1VRV1cx6ITuiAaHOB9MghoVxmqRRdVRTIB3+D/+tlqqq2s76nW+aKSXaO9sNIXVUGMB3m3iOAK9UCCDLkivFpgG+cLNy0nZ" +
          "qzb/JtPyKaGmQmV2A9DIrHo+n+HSomAAINYxoqqpqzyV7sQ5AAISuB3JC0DJRfA/EWOPoV+oFGVIi0QBojTRafg8BLjVBsPpj8BFariOzeB" +
          "Ydgq6ZduHOqb/G3L1BPOuBvDUBjVaxNdKoiHxTMQ2yVj2Q0wlo3YQhdUxzu91a4FYAAcjbYJh/4SwaLkDcCdKk0noWIEpLJxoA6AKFy2gPp" +
          "E0vXZFIRKEVfLwDsH1GPFfC3iA29YAhCACAGghpGDo5DVMe8Y5qGD7mcAFqEGSqo7+TGgjDX9YL3TPsYMA0CGUzStjvN/wOWq/SLdgGvWNM" +
          "UiQRAdg9Zo2JMqK4QEEQAACc0E5DSku9wyJIaQVqp4B1AADAR1suAUpQCFYfZOLqxA9Ypix2l/0A0dRLwDrAKmmQaA9Mi1ptgmahvFoOm+M" +
          "9t9utdRGoF0RMg1rGrbOpHg0IipkOrBg9obVyOR7zCZqvf0O5+Ni/TAGAlVyARi0AUNzoZBsJ4lg6QlojO/5juF7ojIpZB2AaxM8FiEEAAN" +
          "A81crlRhopnodVfB6AEBCqCdY66KmlE9Ay5uPWorndbq0r6sc0CAHgBwEAwLslJ+Gzpc8e53Whh9Sw5na7ta7bASkA8FlkZ0mavUHcIMh18" +
          "E+nPr3D+6IP7Rp9kCJ13AwIGxwXLLKzZCwWE65HiCoEvArlbClQqEnMOuCboUZ0AdkhyCdRQBBV57Z/bAkAZJhOWxQE+fpmEQQshmmJ5Kol" +
          "RTtBPkvafbUeQchQS6QJH4oJkgYxg+C49ldoDeNOKmkFawYQALNBoOekTthOQUu4yfIgWGF8EO0agMbmMAqpk9ZDv5nXLMVagE0hTGMFQxv" +
          "Lk7NyoYwAiAkAUQj0WhX2GCEAoqRB3CCwIghmdgFWzwKkgQBB+Kom45MOBEBcAKhBoPekmyzQZ74xtXEJAWATT8JAYITc03AafCbuNmw16U" +
          "7zLIdDsNgvW6H5ZfQ+NDFr16kZawGWALDa0MUmAsVmrA8QAPEdgBkEWCibQ9FolCkApoHAKNFmAcFMLhCLxaiPBeLpAkwgMJrboSNYM/1hX" +
          "Qcwh8Dol9szJm/XqRlcIN36WwEAphAY+ZJ/KjktZfciz0UGZG79eQLAHAIjRc8J5RSTRX9Jqmyp7I7swc8aANZFsDAQ6BXLRX+LlczzJdKp" +
          "D6/5wLwhUHh9cSMXXYaHaTLWArwnwovgAlycoJALIHqPUf21OqkAiEajXApfEQHg6gRmcgRZXIB1f78MAHB1gkIuyJ5re4QLtj3jqtAApLs" +
          "7EQCBncCoIzwPvUKtLi2iC4i66JWIAAgFgZGbV1tX21JRUjGEAIgf+GnxfA4gFQRGclcR6oPZ2Vkl3cKxDvjM/0WXyAAIC4EMIGTrsVoNRD" +
          "GAZN4bWQJeNgCEhkCvxfMCIV+3rcfjkTZwzZz/SweBqCDgSFfzAAAgQBepnguKq1/LEfjp9EcmAKSAIDO3zHVxW8NsNg5E4OTO/6WGIJ/Nn" +
          "rCdgFZc9BfTHzPWBEZrBZr1AbqAuYJfSifQcwMwUMVIT9EJBHAF0o6AcJmr9TeFE6y+MatbJpJBq4E2hcHvMVXrbzonyOUMJBzB6i4ga6+P" +
          "pZwgW6sFAOAbxf3SirmGZgfAtE6wWp0z7TDsHSnIEazmAmbM+fOp1ApfMlh7EZt2DH5rQwCwMvbf7XYbcgMruICVg99yEBgFQbY1jzDwsSY" +
          "wJD0gRCIRxUzDoTHw0QkMOUJKS70jY8BkQps+fwx8dIKs6vrkCRiqu6Jlg2T170Sf0ohBjxAUpI7pvRBqGHsEBN94k3KhdiDve1lPfVyrlc" +
          "egRwiEVbZrmuta5wpmDHSEAIWiKhteAhRCgEIhBCgUQoBCIQQolJX1f+s3xXud993zAAAAAElFTkSuQmCC)",
        "background-repeat": "no-repeat",
        "background-position": "20px",
        "background-size": "1.5em 1.5em",
      };
    } else if (feedback === ActionButtonResult.FAILURE) {
      this.ngStyle = {
        "background-color": PALETTE.vuurrood, // a failed action shows in the danger colour (#173)
      };
      this.setClasses("btn-danger"); // Define a classe do botão como 'btn-danger' para mostrar erro
    }

    setTimeout(() => {
      this.ngStyle = {};
      this.setClasses("btn-light-blue");
    }, 2000);
  }

  showMessage(feedback: ActionButtonResult) {
    if (
      this.successMessage !== undefined &&
      feedback === ActionButtonResult.SUCCESS
    ) {
      this.tooltips.tooltip =
        this.successMessage.length > 0
          ? this.successMessage
          : this.receivedMessage;
      this.tooltips.containerClass = "tooltipSuccess";
      this.tooltips.show();
    }
    if (
      this.errorMessage !== undefined &&
      feedback === ActionButtonResult.FAILURE
    ) {
      this.tooltips.tooltip =
        this.errorMessage.length > 0 ? this.errorMessage : this.receivedMessage;
      this.tooltips.containerClass = "tooltipError";
      this.tooltips.show();
    }
    return;
  }

  setClasses(extraClasses: string) {
    this.classes =
      "btn align-self-end" +
      (this._fullWidth ? " w-100" : "") +
      " " +
      extraClasses +
      (this._disabled ? " disabled" : "");
  }

  onClickButton(event: Event) {
    if (this.enableSpinner) {
      // already in progress
      return;
    }
    if (!!this.tooltips) {
      this.tooltips.hide();
    }

    this.showSpinner();

    const actionToSubmit = new ActionButtonSubmit(event);
    actionToSubmit.setup().subscribe((result) => {
      if (ActionButtonResult[result] !== undefined) {
        this.actionFeedback(result);
      } else if (typeof result !== "boolean") {
        const msg: Messages = result;
        if (msg.empty) {
          this.actionFeedback(ActionButtonResult.SUCCESS);
        } else if (typeof msg.messagesWithoutKeys !== "undefined") {
          for (const oneMessage of msg.messagesWithoutKeys) {
            this.receivedMessage = this.translate.instant(oneMessage);
          }
          this.actionFeedback(ActionButtonResult.FAILURE);
        } else {
          this.actionFeedback(ActionButtonResult.SUCCESS);
        }
      } else {
        this.actionFeedback(
          result ? ActionButtonResult.SUCCESS : ActionButtonResult.FAILURE
        );
      }
    });
    this.actionEvent.emit(actionToSubmit);
  }
}
